@if (basdata && aoSearchFilter) {
  <rask-page pageTitle="Planera" [actionShow]="visaSkapaArbetsorder()" [actionFn]="create" actionTitle="Skapa arbetsorder">
    <rask-container-block>
      <rask-produktionsmal-plan
        mode="top"
        [produktionsomraden]="basdata.produktionsomraden"
        [handelssortimentsgrupper]="basdata.handelssortimentsgrupper">
      </rask-produktionsmal-plan>
    </rask-container-block>
    <rask-arbetsorder-search [hybridService]="arbetsorderSearchHybridService" [searchFilter]="aoSearchFilter"
    [basdata]="basdata"></rask-arbetsorder-search>
    <rask-container-block class="search-result-panel">
      @if (aoTabs && aoTabs.length > 1) {
        <div style="float: right;"
          [ngStyle]="{display: ngShow(!mapTheatherModeEnabled)}">
          <rask-button aid="buttonRensaArbetsorderTabbar" color="secondary" (click)="closeAllAOTabs()" negative>
            Rensa alla flikar
          </rask-button>
        </div>
      }
      @if (aoTabs) {
        <rask-tabs
          aid="aoTabs"
          id="aoTabs"
          [tabs]="aoTabs"
          parameterName="id"
          [isQueryParam]="false"
          [useRoute]="true"
          [ngStyle]="{display: ngShow(!mapTheatherModeEnabled)}"
          [closable]="true"
          (onCloseTab)="closeAOTab($event)"
          closeIcon="fal fa-times"
          (onMouseEnterTab)="emitMouseOverAOTab($event, true)"
          (onMouseLeaveTab)="emitMouseOverAOTab($event, false)">
        </rask-tabs>
      }
      <rask-vertical-collapsable
        [hideLeftButton]="true"
        (leftClosedChange)="toggleMapTheaterMode($event, true)"
        [leftClosed]="mapTheatherModeEnabled"
        [showBar]="false"
        [showFlap]="true"
        flapPosTop="0px"
        leftClass="ngx-left-side">
        <div left>
          <rask-planera-search-results [active]="noCurrentTab()" [ngStyle]="{display: ngShow(noCurrentTab())}">
          </rask-planera-search-results>
          @for (ao of getAOTabs(); track ao) {
            <div>
              @if (currentTabId === ao.tabId) {
                <rask-planera-detail
                  [arbetsorderid]="ao.tabId"
                  [updatedAtgardBarighet]="updatedAtgardBarighet"
                  [basdata]="basdata"
                  >
                </rask-planera-detail>
              }
            </div>
          }
        </div>
        <div right>
          <div id="planeraDetailTabContainer">
            <rask-planera-tabs [tabs]="planeratabs" (tabChanged)="tabChanged($event)">
            </rask-planera-tabs>
          </div>
          <div class="arbetsorderScrollableContainer" [ngStyle]="{display: ngShow(mode === 'karta')}">
            <rask-planera-karta
            [filterArbetsorderStatus]="$safeNavigationMigration(aoSearchFilter?.status)"></rask-planera-karta>
          </div>
          <div class="arbetsorderScrollableContainer" [ngStyle]="{display: ngShow(mode !== 'karta')}">
            @if (mode === 'schema') {
              <div>
                <div class="row me-0">
                  <div class="col-md-12 pe-0">
                    <rask-arbetsorder-planering-scheduler></rask-arbetsorder-planering-scheduler>
                  </div>
                </div>
              </div>
            }
            @if (mode === 'malPlan') {
              <div [ngStyle]="{display: ngShow(mode === 'malPlan')}">
                <rask-produktionsmal-plan
                  mode="detail"
                  [produktionsomraden]="basdata.produktionsomraden">
                </rask-produktionsmal-plan>
              </div>
            }
          </div>
        </div>
      </rask-vertical-collapsable>
    </rask-container-block>
    @if (currentTabId !== null) {
      <div class="detail-footer">
        <rask-arbetsorder-spara class="button" [updatedAtgardBarighet]="updatedAtgardBarighet"></rask-arbetsorder-spara>
      </div>
    }
    <ng-container footerContent>
    </ng-container>
  </rask-page>
}
